<template>
  <div ref="regalosRef" class="mesa-regalos-section">
    <h2 class="mesa-titulo animate-item">
      MESA DE<br />REGALOS
    </h2>

    <p class="mesa-descripcion animate-item">
      Nuestro mejor regalo es compartir este día con ustedes. <br>
      Pero si desean tener una muestra de cariño con nosotros, les dejamos las siguientes sugerencias.
    </p>

    <!-- BOTÓN REGALOS -->
    <button @click="mostrarRegalos" class="btn-mesa animate-item">
      VER OPCIONES
    </button>

    <!-- TEXTO NO NIÑOS -->
    <p class="mesa-titulo1 animate-item no-ninos">
    </p>

    <!-- BOTÓN NO NIÑOS
    <button @click="mostrarNoNinos" class="btn-mesa animate-item">
      VER MÁS
    </button> -->

    <!-- OVERLAY -->
    <transition name="fade">
      <div v-if="overlayVisible" class="overlay" @click.self="cerrarOverlay">
        <div class="overlay-content" role="dialog" aria-modal="true">

          <!-- 🔹 MODAL NO NIÑOS -->
      

          <!-- 🔹 MODAL REGALOS -->
          <template v-if="overlayTipo === 'regalos'">
            <h3 class="overlay-title">Opciones de regalo</h3>

            <div class="mesa-tarjeta">
              <img src="@/assets/SOBRE.avif" class="icono-sobre" />
              <p class="mesa-lugar">Sobrecito de Amor</p>
              <p class="mesa-numero">
                Pueden encontrar un sobre y un buzón en la recepción.
              </p>
            </div>

            <div class="linea-divisoria"></div>

            <div class="mesa-tarjeta">
              <p class="mesa-lugar">Alejandra Plata Lerma</p>
              <p class="mesa-numero banco">BANAMEX</p>
              <p class="mesa-numero"><strong>CLABE:</strong> 00 2810 7014 4060 7233</p>
              <p class="mesa-numero"><strong>No. Cuenta:</strong>5204 1654 2967 6392</p>
            </div>

            <div class="linea-divisoria"></div>

       

          
          </template>

          <button @click="cerrarOverlay" class="btn-cerrar">
            Regresar a la invitación
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'MesaRegalos',
  setup() {
    const regalosRef = ref(null)
    const overlayVisible = ref(false)
    const overlayTipo = ref('regalos')
    const elementosAnimados = ref([])

    const mostrarRegalos = () => {
      overlayTipo.value = 'regalos'
      overlayVisible.value = true
      document.body.style.overflow = 'hidden'
    }

    const mostrarNoNinos = () => {
      overlayTipo.value = 'ninos'
      overlayVisible.value = true
      document.body.style.overflow = 'hidden'
    }

    const cerrarOverlay = () => {
      overlayVisible.value = false
      document.body.style.overflow = 'auto'
    }

    onMounted(() => {
      nextTick(() => {
        elementosAnimados.value =
          regalosRef.value.querySelectorAll('.animate-item')

        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const index = [...elementosAnimados.value].indexOf(entry.target)
              gsap.fromTo(
                entry.target,
                { opacity: 0, y: 30 },
                {
                  opacity: 1,
                  y: 0,
                  duration: 0.5,
                  delay: index * 0.1,
                  ease: 'power2.out'
                }
              )
              observer.unobserve(entry.target)
            }
          })
        }, { threshold: 0.2 })

        elementosAnimados.value.forEach(el => observer.observe(el))
      })
    })

    return {
      regalosRef,
      overlayVisible,
      overlayTipo,
      mostrarRegalos,
      mostrarNoNinos,
      cerrarOverlay
    }
  }
}
</script>


<style scoped>
/* SECCIÓN BASE */
.mesa-regalos-section {
  background-color: #f2eee8;
  color: #1a1a1a;
  text-align: center;
  padding: 60px 20px;
  font-family: 'Playfair Display', serif;
}

/* TEXTOS */
.mesa-titulo {
  font-size: 26px;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

.mesa-titulo1 {
  font-size: 16px;
  letter-spacing: 2px;
  margin-bottom: 20px;
}
.mesa-descripcion {
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 25px;
}

.no-ninos {
  font-style: italic;
  margin-top: 25px;
}

/* BOTONES */
.btn-mesa {
  background: none;
  border: 1px solid #1a1a1a;
  padding: 8px 18px;
  font-size: 12px;
  margin: 8px;
  cursor: pointer;
}
.btn-mesa:hover {
  background: #1a1a1a;
  color: #fff;
}

/* OVERLAY */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.overlay-content {
  background: #f9f6f1;
  padding: 30px;
  border-radius: 14px;
  max-width: 420px;
  width: 100%;
}

/* TARJETAS */
.mesa-tarjeta {
  margin-bottom: 20px;
}

.mesa-lugar {
  font-size: 18px;
}

.mesa-numero {
  font-size: 13px;
}

.banco {
  font-weight: bold;
}

/* DIVISIÓN */
.linea-divisoria {
  width: 70%;
  height: 1px;
  background: linear-gradient(to right, transparent, #1a1a1a, transparent);
  margin: 25px auto;
}

/* BOTÓN LINKS */
.btn-liverpool {
  display: inline-block;
  margin-top: 10px;
  border: 1px solid #1a1a1a;
  padding: 8px 14px;
  font-size: 12px;
  text-decoration: none;
  color: #fff;
  background: #444;
}

/* CERRAR */
.btn-cerrar {
  margin-top: 20px;
  border: 1px solid #1a1a1a;
  padding: 7px 16px;
  background: none;
  cursor: pointer;
}

/* ANIMACIONES */
.animate-item {
  opacity: 0;
}

/* FADE */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}


<style scoped>
.mesa-regalos-section {
  background-color: #f2eee8;
  color: #1a1a1a;
  font-family: 'Playfair Display', serif;
  text-align: center;
  padding: 60px 20px;
}

.mesa-titulo {
  font-size: 26px;
  font-weight: normal;
  line-height: 1.4;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #1a1a1a;
}

.mesa-descripcion {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  line-height: 1.8;
  color: #444;
  margin-bottom: 30px;
}

.btn-mesa {
  background: none;
  border: 1px solid #1a1a1a;
  padding: 8px 18px;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s ease;
}
.btn-mesa:hover { background: #1a1a1a; color: #fff; }

/* Overlay */
.overlay {
  position: fixed; inset: 0;
  background: rgba(26, 26, 26, 0.9);
  display: flex; justify-content: center; align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
}
.overlay-content {
  background: #f9f6f1;
  color: #1a1a1a;
  border-radius: 12px;
  padding: 30px 20px;
  max-width: 420px; width: 100%;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
  margin: auto;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}
.overlay-title {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.mesa-tarjeta { margin-bottom: 20px; }
.mesa-lugar {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  margin-bottom: 6px;
}
.mesa-numero { font-size: 13px; letter-spacing: 0.5px; }
.mesa-numero.banco { letter-spacing: 1px; font-weight: 600; }

.dato-copiable {
  display: flex; align-items: center; gap: 8px;
  justify-content: center; margin-top: 6px;
}
.btn-copiar {
  border: 1px solid #1a1a1a;
  background: transparent;
  font-size: 11px;
  padding: 4px 10px;
  cursor: pointer;
  transition: .25s ease;
}
.btn-copiar:hover { background: #1a1a1a; color: #fff; }

.btn-cerrar {
  margin-top: 22px;
  background: none;
  border: 1px solid #1a1a1a;
  padding: 7px 16px;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s ease;
}
.btn-cerrar:hover { background: #1a1a1a; color: #fff; }

/* Línea divisoria */
.linea-divisoria {
  width: 70%;
  height: 1px;
  background: linear-gradient(to right, transparent, #1a1a1a, transparent);
  margin: 26px auto;
}

/* Ícono del sobre */
.icono-sobre {
  width: 40px; height: 40px; object-fit: contain;
  margin-bottom: 10px;
  filter: invert(1) brightness(0.3);
}

/* Liverpool / Amazon */
.liverpool .mesa-lugar,
.amazon .mesa-lugar {
  font-size: 19px;
}
.btn-liverpool {
  display: inline-block;
  margin-top: 10px;
  border: 1px solid #1a1a1a;
  padding: 8px 14px;
  font-size: 12px;
  text-transform: uppercase;
  background-color: #434242;
  text-decoration: none;
  color: #f0f0f0;
  transition: .25s ease;
}
.btn-liverpool:hover { background: #1a1a1a; color: #fff; }

.animate-item { opacity: 0; transform: translateY(40px); }

/* Transición overlay */
.fade-enter-active, .fade-leave-active { transition: opacity 0.4s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
